import { ResourceRowData } from '@features/components/CaseOverview/components/AssignedResources/types';
import { OpoContactWithPrimary } from '@/api/apis/case';
import { OpoContact } from '@/api/apis/opo';
import { getContactFullName, getFullName } from '@/utils/helpers';

export type OpoContactRowData = ResourceRowData & {
  type: string;
  isOpoUser: boolean;
};

export const searchOpoContacts = (searchTerm: string, contacts?: OpoContact[]) =>
  contacts?.filter((contact) => {
    const normalizedSearchTerm = searchTerm.toLowerCase();
    const fullName = getContactFullName(contact.firstName || '', contact.lastName || '').toLowerCase();
    const primaryPhone = contact.primaryPhone || '';

    return fullName.includes(normalizedSearchTerm) || primaryPhone.includes(searchTerm);
  }) ?? [];

export const mapContactRowData = (
  contact: OpoContact,
  assignedOpoContacts: OpoContactWithPrimary[],
): OpoContactRowData => {
  const { id, userId, firstName, lastName, primaryPhone, secondaryPhone, photoPath, isOpoUser } = contact;

  return {
    id,
    userId: userId || '',
    firstName: firstName || '',
    lastName: lastName || '',
    photoPath: photoPath || '',
    primaryPhone: primaryPhone || '',
    secondaryPhone: secondaryPhone || '',
    isOpoUser,
    type: isOpoUser ? 'User' : 'Contact',
    assigned: assignedOpoContacts.some((assignedContact) => assignedContact.opoContactId === id),
  };
};

export const sortContacts = (a: ResourceRowData, b: ResourceRowData) => {
  const aFullName = getFullName(a.firstName, a.lastName).toLowerCase();
  const bFullName = getFullName(b.firstName, b.lastName).toLowerCase();

  return aFullName.localeCompare(bFullName);
};
